module.exports = __webpack_public_path__ + "static/fabrics-f89c80c4b49eab65a3c7d2a520dadaf3.png";